import './screen-utils.scss'

type ScreenSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'
const sizes: ScreenSize[] = ['xs', 'sm', 'md', 'lg', 'xl']

function isScreenSize(value: unknown): value is ScreenSize {
  return sizes.includes(value as ScreenSize)
}

export function getScreenSize(): ScreenSize {
  const beforeContent = window.getComputedStyle(window.document.body, ':before').content
  const userAgent = window.navigator.userAgent

  if (userAgent === 'ReactSnap') {
    // return md for reactsnap so we default to desktop video in prerendered html
    return 'md'
  }

  if (beforeContent) {
    const screenSize = beforeContent.replace(/"/g, '')
    if (isScreenSize(screenSize)) {
      return screenSize
    }
  }
  // return md instead of throw error so reactsnap can get a proper size
  // throw new Error("Could not determine screen size");
  return 'md'
}

export function screenBiggerThan(size: ScreenSize): boolean {
  return sizes.indexOf(getScreenSize()) > sizes.indexOf(size)
}

export function screenSmallerThan(size: ScreenSize): boolean {
  return sizes.indexOf(getScreenSize()) < sizes.indexOf(size)
}
